import type { Visit } from '.';

import { createMessage, createMessages, SB } from '@play-co/replicant';

export const visitMessages = ({
  PetStats,
  VisitRecord,
  Fate,
}: Visit['$DEPENDENCIES']) =>
  createMessages(SB.object({ ...PetStats.schema, ...VisitRecord.schema }))({
    /**
     * Record visit from friend
     */
    trackVisit: createMessage(
      SB.object({ name: SB.string() }),

      (state, { name }, { senderId, timestamp }) => {
        Fate.api.resolveStatusEffect(
          (state as unknown) as any,
          'hadVisitor',
          true,
          timestamp,
        );

        VisitRecord.modifiers.incrementVisitedCount(state, {
          name,
          friendId: senderId,
          now: timestamp,
        });
      },
    ),

    /**
     * Kick out visitor due to visited player coming online
     */
    kickVisitor: createMessage(SB.object({}), (state, _, { senderId }) => {
      if (state.visit.visitSession?.friendId === senderId) {
        state.visit.visitSession.isKickedOut = true;
      }
    }),

    /**
     * Delete visit session
     */
    deleteVisitSession: createMessage(SB.object({}), (state) => {
      delete state.visit.visitSession;
    }),
  });
